module.exports = __webpack_public_path__ + "img/setsul.8390d834.jpg";